export default "__VITE_ASSET__CU3vpZ35__"